import {
  Avatar,
  IconButton,
  Menu,
  MenuItemProps,
  useBreakpoints,
  useRuntimeEnv,
  useRuntimeEnvRolesIncludes,
  useTranslation,
  useTranslationLang,
  useTranslationRoute,
  useUrlActive,
  useUserProfilePicture,
} from "@bsm/component";
import { useCallback, useMemo } from "react";
import { Link } from "react-router-dom";
import pkg from "../../../package.json";
import { useLeftSideBarMenu } from "./hooks/useLeftSideBarMenu";
// import { usePremiumRoles } from "./hooks/usePremiumRoles";
// import { useFreeRoles } from "./hooks/useFreeRoles";
import _ from "lodash";
import "./css/navbar.css";

export const AdminLeftSideBar = ({
  open,
  onToggle,
}: {
  open: boolean;
  onToggle: () => void;
}) => {
  const { lang } = useTranslationLang()
  const profilePictureUrl = useUserProfilePicture();
  const { runtimeEnv } = useRuntimeEnv();
  const roleIncludes = useRuntimeEnvRolesIncludes();
  const url = useTranslationRoute();
  const t = useTranslation();
  const menuItems = useLeftSideBarMenu();
  const { md } = useBreakpoints();
  // const freeRoles = useFreeRoles();
  // const premiumRoles = usePremiumRoles();
  const isActive = useUrlActive();

  // const isSubsetOfFreeRoles = useCallback(
  //     (menu: MenuItemProps): boolean =>
  //         menu.roles?.every((role: string) => freeRoles?.includes(role)),
  //     [freeRoles]
  // );

  const transformedMenuItems = useMemo(() => {
    return menuItems
      .map((menu) => {
        return {
          ...menu,
          items: menu.items?.filter(
            (item) =>
              _.isEmpty(item?.roles) ||
              !!item?.roles?.every((role: string) => roleIncludes(role))
          ),
        };
      })
      .filter((item) => !_.isEmpty(item.items));
  }, [lang]);

  return (
    <aside className={`sidebar-left flex-col hidden md:flex ${open ? "open" : ""}`}>
      <div
        className={`flex items-center h-[68px] sticky py-2 ${open ? "px-4" : "px-5 justify-center"}`}
      >
        <Link to="/">
            <img src={open ? "/assets/img/logo.png" : "/assets/img/favicon.png"} className={open ? "h-16" : ""} alt="Logo" />
        </Link>
      </div>
      <div className="bg-[#221B44] overflow-y-auto flex-1 space-y-4">
        <div
          className={`
                flex items-center text-xs gap-2 text-white
                opacity-1 transition-all duration-150 !mt-[15px]
                ${!open ? "hidden" : "px-5"} 
                `}
        >
          <Link to={url(`user/${runtimeEnv.personnel?.id}`)}>
            <Avatar
              src={profilePictureUrl(runtimeEnv?.personnel?.id!)}
              fullName={runtimeEnv?.user?.fullName}
              className="!w-[64px] !h-[50px]"
            />
          </Link>
          <div className="flex flex-col gap-2 justify-center">
            <Link to={url(`user/${runtimeEnv.personnel?.id}`)}>
              <h6 className="font-bold text-white">
                {runtimeEnv.user?.fullName}
              </h6>
            </Link>
            <Link to={url(`organisation/${runtimeEnv.organisation?.id}`)}>
              <span className="text-center w-full">
                {runtimeEnv.organisation?.designation}
              </span>
            </Link>
          </div>
        </div>
        <div className={`${open ? "px-3" : ""}`}>
          <Menu
            items={transformedMenuItems}
            onlyStartIcon={!md && !open}
            className="text-white"
            // disabledFn={(menu) => !isSubsetOfFreeRoles(menu)}
            activeFn={(menu) => !!menu.link && isActive(menu.link)}
          />
        </div>
        <div className="mt-4 px-4 text-[12px] text-white text-center">
          <a className={!open ? "hidden" : ""} href="/">
            {t(`Generic.de.${process.env.REACT_APP_NAME}`)}-{pkg.version}
          </a>{" "}
          © {new Date().getFullYear()}
        </div>
      </div>
    </aside>
  );
};

type AdminLeftSideBarProps = {
  open: boolean;
};
